import { render, staticRenderFns } from "./commonsubscribe.vue?vue&type=template&id=b95d331e&scoped=true&"
import script from "./commonsubscribe.vue?vue&type=script&lang=js&"
export * from "./commonsubscribe.vue?vue&type=script&lang=js&"
import style0 from "./commonsubscribe.vue?vue&type=style&index=0&id=b95d331e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b95d331e",
  null
  
)

export default component.exports